import { makeStyles } from 'tss-react/mui';
import React from 'react';
// @ts-ignore
import { translate } from '../../../base/i18n';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles()(() => {
    return {
        container: {
            marginLeft: '5px'
        },
        label: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.2rem',
            cursor: 'pointer',
            color: 'white',
            marginRight: 15,
        },
        checkBox: {
            appearance: 'none',
            cursor: 'pointer',
            '&:before': {
                content: '""',
                display: 'inline-block',
                width: '15px',
                height: '15px',
                border: '1px solid #6f9c63',
                borderRadius: '4px',
                verticalAlign: 'middle'
            },
            '&:checked': {
                backgroundColor: '#6f9c63',
                borderColor: '#6f9c63',
                borderRadius: '4px',
                '&:before': {
                    content: '""',
                    backgroundColor: '#6f9c63',
                    borderColor: '#6f9c63',
                    borderRadius: '4px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50%'
                }
            }
        },
        title: {
            marginBottom: 5,
            color: '#fff',
            fontWeight: 'bold'
        }
    };
});
const InputCheckbox = React.forwardRef(({ onClick }, ref) => {
    const { classes: styles } = useStyles();
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("p", { className: styles.title }, t('chat.braillemode')),
            React.createElement("input", { className: styles.checkBox, id: 'btn1', name: 'inputCheckBox', onClick: onClick, type: 'checkbox', value: 'tapTilo' }),
            React.createElement("label", { className: styles.label, htmlFor: 'btn1' }, t('chat.taptilo')),
            React.createElement("input", { className: styles.checkBox, id: 'btn2', name: 'inputCheckBox', onClick: onClick, type: 'checkbox', value: 'brailleSense' }),
            React.createElement("label", { className: styles.label, htmlFor: 'btn2' }, t('chat.keyboard')))));
});
export default translate(InputCheckbox);
